import { Box, Chip, Paper, Typography } from '@mui/material'
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined'
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined'
import { useTranslations } from 'next-intl'

interface DestinationClimateSupplementProps {
    avoidMonths: string[]
    peakSeason: string
    offPeakSeason: string
}

const DestinationClimateSupplement: React.FC<DestinationClimateSupplementProps> = ({
    avoidMonths,
    peakSeason,
    offPeakSeason
}) => {
    const t = useTranslations('destinationPage')
    const hasContent = avoidMonths.length > 0 || peakSeason || offPeakSeason
    if (!hasContent) return null

    return (
        <Paper variant="outlined" sx={{ borderRadius: 2, p: { xs: 1.5, sm: 2 }, mb: 3 }}>
            {avoidMonths.length > 0 && (
                <Box sx={{ mb: peakSeason || offPeakSeason ? 2 : 0 }}>
                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, display: 'block', mb: 0.75 }}>
                        {t('avoidMonths')}
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        {avoidMonths.map(month => (
                            <Chip key={month} size="small" label={month} sx={{ bgcolor: 'error.50', fontSize: '0.75rem' }} />
                        ))}
                    </Box>
                </Box>
            )}

            {peakSeason && (
                <Box sx={{ mb: offPeakSeason ? 1.5 : 0 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <WbSunnyOutlinedIcon sx={{ fontSize: 16, color: 'warning.main' }} />
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>{t('peakSeason')}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                        {peakSeason}
                    </Typography>
                </Box>
            )}

            {offPeakSeason && (
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 0.5 }}>
                        <AcUnitOutlinedIcon sx={{ fontSize: 16, color: 'info.main' }} />
                        <Typography variant="caption" sx={{ fontWeight: 600 }}>{t('offPeakSeason')}</Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
                        {offPeakSeason}
                    </Typography>
                </Box>
            )}
        </Paper>
    )
}

export default DestinationClimateSupplement
export type { DestinationClimateSupplementProps }
